import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  showIcon?: boolean;
}
export const Button = ({
  children,
  className = '',
  showIcon = true,
  ...props
}: ButtonProps) => {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative group overflow-hidden rounded-lg bg-neon text-black font-display text-xl md:text-2xl 
        py-4 px-8 uppercase tracking-wide flex items-center justify-center gap-3
        shadow-neon hover:shadow-neon-strong transition-shadow duration-300
        ${className}
      `} {...props} data-id="element-210">
      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-12" data-id="element-211" />

      {showIcon && <Zap className="w-6 h-6 md:w-8 md:h-8 fill-black" data-id="element-212" />}
      <span className="relative z-10 mt-1" data-id="element-213">{children}</span>
    </motion.button>;
};